import { WhatsNewResponse, Tag, Category } from '../interfaces/whatsNew';

export class WhatsNew {
  public id: number;
  public title: string;
  public content: string; // HTML content
  public isGlobal: boolean;
  public publishedAt: string | null;
  public isActive: boolean;
  public sendPushNotifications: boolean;
  public tags: Tag[]; // NEW: Array of tags
  public category: Category | null; // NEW: Category object (nullable)
  public createdAt: string;
  public updatedAt: string | null;
  public previewImageUrl?: string | null;
  public createdBy: {
    id: number;
  };

  public constructor(payload?: WhatsNewResponse | any) {
    this.id = payload && payload.id ? payload.id : 0;
    this.title = payload && payload.title ? payload.title : '';
    this.content = payload && payload.content ? payload.content : '';
    this.isGlobal = payload && payload.isGlobal !== undefined ? payload.isGlobal : true;
    this.publishedAt = payload && payload.publishedAt ? payload.publishedAt : null;
    this.isActive = payload && payload.isActive !== undefined ? payload.isActive : false;
    this.sendPushNotifications = payload && payload.sendPushNotifications !== undefined ? payload.sendPushNotifications : false;
    this.tags = payload && payload.tags && Array.isArray(payload.tags) ? payload.tags : [];
    this.category = payload && payload.category ? payload.category : null;
    this.createdAt = payload && payload.createdAt ? payload.createdAt : '';
    this.updatedAt = payload && payload.updatedAt ? payload.updatedAt : null;
    this.createdBy = payload && payload.createdBy ? payload.createdBy : { id: 0 };
  }
}
